export default __webpack_public_path__ + "static/media/w_mas_2024_a.61aec9ca.jpg";